import { EducationsService } from "@/common/api.service";
import { FETCH_EDUCATION_DATA, FETCH_INDIVIDUAL_EDUCATION_DATA, RESET_STATE } from "./actions.type";
import { SET_EDUCATIONS_DATA, SET_INDIVIDUAL_EDUCATION_DATA,SET_EDUCATION_ERROR, STATE_RESET } from "./mutations.type";


const initialState = () => {
  return {
    educationdata: [],
    individualeducationdata: [],
    educationerror: [],
  }
};

export const state = initialState();

const actions = {

  async [FETCH_EDUCATION_DATA](context, slug) {
    return await EducationsService.get(slug).then((response) => {
      context.commit(SET_EDUCATIONS_DATA, response.data)
      return response
    }).catch(({ response }) =>{
      context.commit(SET_EDUCATION_ERROR, response.data.errorMessage)
      return response
    })
  },

  async [FETCH_INDIVIDUAL_EDUCATION_DATA](context, slug) {
    return await EducationsService.get(slug).then(({ data }) => {
      context.commit(SET_INDIVIDUAL_EDUCATION_DATA, data.data)
      return data
    }).catch(({ response })=>{
      context.commit(SET_EDUCATION_ERROR, response.data.errorMessage)
      return response
    })
  },


  [RESET_STATE]({ commit }) {
    commit(STATE_RESET)
  }

}

const mutations = {

  [SET_EDUCATIONS_DATA](state, educationdata) {
    state.educationdata = educationdata
  },
  [SET_INDIVIDUAL_EDUCATION_DATA](state, individualeducationdata) {
    state.individualeducationdata = individualeducationdata
  },
  [SET_EDUCATION_ERROR](state, error) {
    state.educationerror = error
  },  
  [STATE_RESET](state) {
    Object.assign(state,initialState())
  }

}

const getters = {
  
  educationdata(state) {
    return state.educationdata;
  },
  individualeducationdata(state) {
    return state.individualeducationdata;
  },


}

export default {
    state,
    getters,
    actions,
    mutations
};